import store from '../store/Store';
import type BookingMeetingType from 'owa-service/lib/contract/BookingService';
import { DEFAULT_MEETING_TYPE } from './isDefaultMeetingType';

const getDefaultMeetingType = (): BookingMeetingType | undefined => {
    const meetingTypes = store.meetingTypes;
    const defaultMeetingType = meetingTypes?.get(DEFAULT_MEETING_TYPE);
    return defaultMeetingType;
};

export default getDefaultMeetingType;
